import createIcon from '../../createIcon';

/**
 * @component @name AdminPanelSettings
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgMTFDMTcuMzQgMTEgMTcuNjcgMTEuMDQgMTggMTEuMDlWNi4yN0wxMC41IDNMMyA2LjI3VjExLjE4QzMgMTUuNzIgNi4yIDE5Ljk3IDEwLjUgMjFDMTEuMDUgMjAuODcgMTEuNTggMjAuNjggMTIuMSAyMC40NUMxMS40MSAxOS40NyAxMSAxOC4yOCAxMSAxN0MxMSAxMy42OSAxMy42OSAxMSAxNyAxMVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNyAxM0MxNC43OSAxMyAxMyAxNC43OSAxMyAxN0MxMyAxOS4yMSAxNC43OSAyMSAxNyAyMUMxOS4yMSAyMSAyMSAxOS4yMSAyMSAxN0MyMSAxNC43OSAxOS4yMSAxMyAxNyAxM1pNMTcgMTQuMzhDMTcuNjIgMTQuMzggMTguMTIgMTQuODkgMTguMTIgMTUuNUMxOC4xMiAxNi4xMSAxNy42MSAxNi42MiAxNyAxNi42MkMxNi4zOSAxNi42MiAxNS44OCAxNi4xMSAxNS44OCAxNS41QzE1Ljg4IDE0Ljg5IDE2LjM4IDE0LjM4IDE3IDE0LjM4Wk0xNyAxOS43NUMxNi4wNyAxOS43NSAxNS4yNiAxOS4yOSAxNC43NiAxOC41OEMxNC44MSAxNy44NiAxNi4yNyAxNy41IDE3IDE3LjVDMTcuNzMgMTcuNSAxOS4xOSAxNy44NiAxOS4yNCAxOC41OEMxOC43NCAxOS4yOSAxNy45MyAxOS43NSAxNyAxOS43NVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AdminPanelSettings = createIcon('AdminPanelSettings', [
  [
    'path',
    {
      d: 'M17 11C17.34 11 17.67 11.04 18 11.09V6.27L10.5 3L3 6.27V11.18C3 15.72 6.2 19.97 10.5 21C11.05 20.87 11.58 20.68 12.1 20.45C11.41 19.47 11 18.28 11 17C11 13.69 13.69 11 17 11Z',
      key: 'ov48mt',
    },
  ],
  [
    'path',
    {
      d: 'M17 13C14.79 13 13 14.79 13 17C13 19.21 14.79 21 17 21C19.21 21 21 19.21 21 17C21 14.79 19.21 13 17 13ZM17 14.38C17.62 14.38 18.12 14.89 18.12 15.5C18.12 16.11 17.61 16.62 17 16.62C16.39 16.62 15.88 16.11 15.88 15.5C15.88 14.89 16.38 14.38 17 14.38ZM17 19.75C16.07 19.75 15.26 19.29 14.76 18.58C14.81 17.86 16.27 17.5 17 17.5C17.73 17.5 19.19 17.86 19.24 18.58C18.74 19.29 17.93 19.75 17 19.75Z',
      key: '1fkb78',
    },
  ],
]);

export default AdminPanelSettings;
